import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      type: '',
      eventId: '',
      date: '',
      event: {},
      cnt : 0,
      intervalAlias: ''
    },
  ],
  event: {
    id: 0,
    type: '',
    eventId: '',
    date: '',
    event: {},
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/events?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 0,
    limit: 20,
  },
};

function events(state = initialState, action) {
  switch (action.type) {
    case types.EVENTS_FETCH_SUCCESS:
    // console.log("Action.res----", action.res)
      return assign({}, state, action.res);
    case types.EVENTS_FETCH_ERROR:
    case types.EVENT_DELETE_ERROR:
    case types.EVENT_EDIT_ERROR:
    case types.EVENT_FETCH_ERROR:
    case types.EVENT_SET_ERROR:
    case types.EVENT_FETCH_LAST60_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.EVENT_FETCH_SUCCESS:
    case types.EVENT_SET_SUCCESS:
    case types.EVENT_FETCH_LAST60_SUCCESS:
      return assign({}, state, {
        event: action.res,
      });
    case types.EVENT_DELETE_SUCCESS:
      return assign({}, state, {
        eventDelete: action.res.ok,
      });
    case types.EVENTS_CLEAR_ERRORS:
    case types.EVENT_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default events;



// WEBPACK FOOTER //
// ./src/reducers/events.js